var Index_object_recent_slider = document.querySelector('.Index_object_recent_slider');

if (Index_object_recent_slider) {
    new Swiper('.Index_object_recent_slider', {
        loop: true,
        grabCursor: true,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: 2,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
            0: {
                spaceBetween: 10,
                slidesPerView: 1
            },
            750: {
                spaceBetween: 16,
                slidesPerView: 2
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
}